<a
  *ngIf="category"
  [attr.mmTestId]="'CUSTOM_HUB.CATEGORY_CARD'"
  class="custom-hub-card"
  fxLayout="column"
  fxLayoutAlign="center center"
  [href]="marketplaceLink + categoryRoute + '/' + category?.slug"
  (click)="onCategoryClick()" >

  <div
    [mmTestTarget]="'card-' + category?.name | kebabCase"
    class="custom-hub-card__image"
    [ngStyle]="{'background-image': 'url(\'' + (categoryBanner && categoryBanner.url) + '\')'}">
  </div>

  <div
    [mmTestTarget]="'card-' + category?.name | kebabCase"
    class="custom-hub-card__title"
    fxLayoutAlign="center center">

    <p> {{ category?.name }} </p>

  </div>

</a>
